import router from '@/router';
import { http } from 'vue';
import { API_BASE_PATH } from '../../consts';
let countDownInterval;
let lastUpdate;
let lastPerformanceId;
export default {
  setSelectedShow({ commit }, selectedShow) {
    commit('selectedShow', { selectedShow: selectedShow });
  },
  startCountDown({ dispatch, commit, getters }, initValue = 5 * 60) {
    commit('countdown', initValue);
    if (countDownInterval) {
      clearInterval(countDownInterval);
    }
    countDownInterval = setInterval(() => {
      if (getters.countdown) {
        commit('countdown', getters.countdown - 1);
        dispatch('levelChanged', null, { root: true });
      } else {
        clearInterval(countDownInterval);
        dispatch('stopCountDown');
        dispatch('levelChanged', null, { root: true });
        commit('selectedSeats', []);
        commit('holdId', '');
        router.push({ name: 'seats', params: { title: router.currentRoute.params.title } });
      }
    }, 1000);
  },
  stopCountDown({ commit }) {
    clearInterval(countDownInterval);
    commit('countdown', -2);
  },
  changedPerformanceId({ dispatch, commit, getters }) {
    commit('selectedSeats', []);
    return dispatch('resetCountDownReleaseSeat');
  },
  resetCountDownReleaseSeat({ commit, dispatch }) {
    commit('countdown', -2);
    return dispatch('releaseSeats');
  },
  loadTicket({ commit, getters }) {
    const selectedShow = getters['selectedShow'];
    const performanceId = getters['performanceId'];
    if (Date.now() - lastUpdate < 15000 && performanceId === lastPerformanceId) {
      return Promise.resolve();
    }
    lastUpdate = Date.now();
    lastPerformanceId = performanceId;
    if (performanceId) {
      return http
        .post(API_BASE_PATH + '/api/get-seat-plan-for-perf', { params: { perfid: performanceId } })
        .then(response => {
          const resp = response.data.SeatPlan;
          const { GridRef, Layout, ResponseText, Tax, ServiceCharge, Tickets } = resp;
          const { Width, Height } =
            GridRef && GridRef.Width ? GridRef : { Width: 10000, Height: 10000 };
          // const {Ticket} = Layout.Pricing.Tickets;
          if (Layout) {
            const seats = {
              seats: Layout.Seats.Seat,
              gridWidth: +Width,
              gridHeight: +Height,
              seatTypes: Layout.SeatTypes.SeatType
            };

            commit('seats', seats);
            const prGroups = Layout.Pricing.PriceGroups.PriceGroup;
            if (Array.isArray(prGroups)) {
              commit('priceGroups', Layout.Pricing.PriceGroups.PriceGroup);
            } else {
              commit('priceGroups', [Layout.Pricing.PriceGroups.PriceGroup]);
            }
          
            commit('ticketDetail', {
              ticketDetail: {
                Ticket: Tickets,
                ServiceCharge: +ServiceCharge || 1.5,
                tax: +Tax || 0,
                cinemaName: 'Pruneyard Cinemas',
                salonName: 'Aud ' + selectedShow.Aud
              }
            });
          } else {
            throw 'There is no defined layout for seats';
          }
        });
    } else {
      return Promise.reject('performance does not exist');
    }
  },
  loadSeats() {
    return http.get(`http://www.mocky.io/v2/5d6095732f00005b005f3c93?$format=json`);
  },
  setTicketCount({ commit, getters, dispatch }, { ticketTypeCount }) {
    if (
      getters.holdId &&
      JSON.stringify(getters.ticketTypeCount) !== JSON.stringify(ticketTypeCount)
    ) {
      dispatch('changedPerformanceId');
    }
    commit('ticketTypeCount', { ticketTypeCount });
  },
  setSelectedSeats({ commit }, selectedSeats) {
    commit('selectedSeats', { selectedSeats });
  },
  setPaymentData({ commit }, paymentData) {
    commit('paymentData', { paymentData });
  },

  getGiftCardDetail({ commit }, { giftCardNumber, giftCardPin }) {
    return http
      .post(API_BASE_PATH + '/api/gift-information', {
        params: { giftcard: giftCardNumber, giftpin: giftCardPin }
      })
      .then(res => {
        const { GiftCard } = res.data.Response.Packet;
        let { GiftNumber, DebitRemain, Registered, Error } = GiftCard;
        // DebitRemain = 1213
        // Error = ''
        if (DebitRemain) {
          commit('giftcard', { giftCardBalance: DebitRemain, giftCardNumber, giftCardPin });
        }
        return { DebitRemain, Error };
      });
  },

  holdSeats({ getters, dispatch, commit }, selectedSeats) {
    const performanceID = getters.performanceId;
    const seats = selectedSeats.map(seat => {
      return { row: seat.RowNum, col: seat.ColNum };
    });
    return http
      .post(API_BASE_PATH + '/api/hold-seat', { perfId: performanceID, seats })
      .then(resp => {
        const res = resp.body.Response;
        if (res.Code === '-1') {
          const TransactionID = res.Packet.Response.TransactionID;
          dispatch('startCountDown');
          commit('holdId', TransactionID);
          return { TransactionID };
        } else {
          return { Error: res.ErrorText };
        }
      })
      .catch(err => {
        return { Error: err };
      });
  },
  releaseSeats({ dispatch, commit, getters }) {
    const holdID = getters.holdId;
    commit('logID', null);
    if (holdID) {
      commit('holdId', '');
      return http
        .post(API_BASE_PATH + '/api/release-seat', { params: { transactionid: holdID } })
        .then(() => {
          dispatch('loadTicket');
        });
    }
  },

  sendLogData({ getters, commit }, selectedMovie) {
    const selectedSeats = getters.selectedSeats;
    if (!selectedSeats) {
      console.log('selected seats are empty');
      return Promise.reject('Please Try Again');
    }
    const { giftCardBalance, giftCardNumber, giftCardMaxUsage, giftCardPin } = getters;
    const data = {
      holdTransactionId: getters.holdId,
      ticketTypeCount: getters.ticketTypeCount,
      ticketTypeCodes: getters.ticketTypeCodes,
      performanceId: getters.performanceId,
      selectedSeats: selectedSeats,
      sections: selectedSeats.map(seat => seat.Section),
      paymentData: getters.paymentData,
      giftCard: { giftCardBalance, giftCardNumber, giftCardPin, giftCardMaxUsage },
      movieName: selectedMovie.Title
    };
    return http
      .post(API_BASE_PATH + '/api/payment', data)
      .then(res => res)
      .catch(e => {
        return e.msg;
      });
  },
  buyTicket({ getters }, selectedMovie) {
    const selectedSeats = getters.selectedSeats;
    if (!selectedSeats) {
      console.log('selected seats are empty');
      return Promise.reject('Please Try Again');
    }
    const data = {
      logID: getters.logID,
      holdTransactionId: getters.holdId,
      ticketTypeCount: getters.ticketTypeCount,
      ticketTypeCodes: getters.ticketTypeCodes,
      performanceId: getters.performanceId,
      selectedSeats: selectedSeats,
      sections: selectedSeats.map(seat => seat.Section),
      paymentData: getters.paymentData,
      movieName: selectedMovie.Title
    };
    return http.post(API_BASE_PATH + '/api/post-data', data);
  }
};
